import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Big from 'UIComponents/elements/Big';
import H1 from 'UIComponents/elements/headings/H1';
import UIFlex from 'UIComponents/layout/UIFlex';
import { isValidElement, useMemo } from 'react';
import MediaQuery from '../../layout/components/MediaQuery';
import * as ScreenSizes from '../../layout/constants/ScreenSizes';
import ResultsSection from './ResultsSection';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function StorefrontResultsHeader({
  className,
  description,
  renderedFiltersPanel,
  renderedResultsCount: passedRenderedResultsCount,
  renderedResultsFilters,
  renderedSortDropdown,
  resultsCount,
  searchTerm,
  title,
  ungatedMobile,
  viewToggle
}) {
  const renderedResultsCount = useMemo(() => {
    if (passedRenderedResultsCount) return passedRenderedResultsCount;
    if (!resultsCount) return null;
    if ( /*#__PURE__*/isValidElement(resultsCount)) return resultsCount;
    const {
      start,
      end,
      total
    } = resultsCount;
    if (searchTerm) {
      return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "marketplace-ui-common.storefront.resultsHeader.searchResultsCount",
        options: {
          start,
          end,
          count: total,
          searchTerm
        }
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplace-ui-common.storefront.resultsHeader.resultsCount",
      options: {
        start,
        end,
        count: total
      }
    });
  }, [passedRenderedResultsCount, resultsCount, searchTerm]);
  return /*#__PURE__*/_jsxs("div", {
    className: className,
    children: [ungatedMobile &&
    /*#__PURE__*/
    // only show on mobile
    _jsx(MediaQuery, {
      maxScreenSize: ScreenSizes.SM,
      children: /*#__PURE__*/_jsx(ResultsSection, {
        className: "m-bottom-6",
        gutterSize: "sm",
        children: renderedResultsFilters
      })
    }), title && /*#__PURE__*/_jsx(ResultsSection, {
      className: ungatedMobile ? 'm-bottom-5' : undefined,
      gutterSize: "sm",
      children: /*#__PURE__*/_jsx(H1, {
        "aria-level": 1,
        "data-selenium-id": "storefront-results-header-title",
        className: 'is--heading-2' + (ungatedMobile ? " m-bottom-5" : ""),
        children: title
      })
    }), description && /*#__PURE__*/_jsx(ResultsSection, {
      children: /*#__PURE__*/_jsx(Big, {
        children: description
      })
    }), /*#__PURE__*/_jsx(ResultsSection, {
      "data-test-id": "desktop-controls",
      gutterSize: "xs",
      children: /*#__PURE__*/_jsxs(UIFlex, {
        align: "center",
        justify: "between",
        wrap: "wrap",
        children: [/*#__PURE__*/_jsx(Big, {
          children: renderedResultsCount
        }), /*#__PURE__*/_jsx(MediaQuery, {
          minScreenSize: "sm",
          children: /*#__PURE__*/_jsxs("div", {
            children: [viewToggle, renderedSortDropdown]
          })
        })]
      })
    }), (renderedFiltersPanel || renderedSortDropdown) && /*#__PURE__*/_jsx(MediaQuery, {
      maxScreenSize: "xs",
      children: /*#__PURE__*/_jsxs(UIFlex, {
        justify: "between",
        className: "m-bottom-2",
        "data-test-id": "mobile-controls",
        children: [renderedFiltersPanel, renderedSortDropdown]
      })
    }), ungatedMobile ?
    /*#__PURE__*/
    // only show on desktop
    _jsx(MediaQuery, {
      minScreenSize: ScreenSizes.SM,
      children: /*#__PURE__*/_jsx(ResultsSection, {
        gutterSize: "sm",
        children: renderedResultsFilters
      })
    }) : /*#__PURE__*/_jsx(ResultsSection, {
      gutterSize: "sm",
      children: renderedResultsFilters
    })]
  });
}